module.exports = __webpack_public_path__ + "static/cities-delight-1-104ed93f280a9078af10f9ee5d5048e9.jpg";